import { faCircleInfo, faHeartPulse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const MindfulnessForm = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <section>
      <div className="max-w-4xl mx-auto p-6 space-y-8 text-portal-dark-blue">
        <h1 className="text-[#41264B] text-2xl font-semibold border-b border-[#41264B]">
          Mindfulness
        </h1>
        <section className="pb-6">
          <div className="border border-blue-400 bg-blue-50 text-blue-800 p-4 rounded-lg flex items-start gap-3">
            <FontAwesomeIcon icon={faCircleInfo} className="mt-1 text-lg" />
            <p className="text-sm">
              You must not use this service for emergencies or urgent
              conditions, as this may delay necessary treatment.
            </p>
          </div>

          <div className="mt-6">
            <h3 className="text-xl font-semibold text-[#41264B] mb-2">
              How it works
            </h3>
            <p className="text-[#41264B] whitespace-pre-line">
              We have a range of Mindfulness Services available to support you
            </p>
          </div>

          <div className="space-y-4 mt-4">
            <div className="flex items-start gap-3 text-sm text-gray-300">
              <FontAwesomeIcon
                icon={faHeartPulse}
                className="text-[#407cb9] mt-1"
              />
              <p>
                <span className="text-[#407cb9] font-semibold">
                  One to One Therapy:
                </span>
                <span className="text-[#41264B]">
                  {" "}
                  Identify and implement the most appropriate support
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 text-sm text-gray-300">
              <FontAwesomeIcon
                icon={faHeartPulse}
                className="text-[#407cb9] mt-1"
              />
              <p>
                <span className="text-[#407cb9] font-semibold">
                  Guided Relaxation Sessions:
                </span>
                <span className="text-[#41264B]">
                  {" "}
                  Sessions to promote relaxation
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 text-sm text-gray-300">
              <FontAwesomeIcon
                icon={faHeartPulse}
                className="text-[#407cb9] mt-1"
              />
              <p>
                <span className="text-[#407cb9] font-semibold">
                  Relaxation Room Podcast:
                </span>
                <span className="text-[#41264B]">
                  {" "}
                  Our popular podcast of mindfulness recordings
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 text-sm text-gray-300">
              <FontAwesomeIcon
                icon={faHeartPulse}
                className="text-[#407cb9] mt-1"
              />
              <p>
                <span className="text-[#407cb9] font-semibold">
                  Regular live sessions with June:
                </span>
                <span className="text-[#41264B]">
                  {" "}
                  Regular evening group sessions, covering Mindfulness and
                  Relaxation
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 text-sm text-gray-300">
              <FontAwesomeIcon
                icon={faHeartPulse}
                className="text-[#407cb9] mt-1"
              />
              <p>
                <span className="text-[#407cb9] font-semibold">
                  Mastering Mindfulness:
                </span>
                <span className="text-[#41264B]">
                  {" "}
                  A 4-week online course to help you build resilience and manage
                  stress and anxiety
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <button
              onClick={() =>
                window.open(
                  "https://schooladvice.co.uk/webinars-and-events",
                  "_blank",
                )
              }
              className="w-full py-2 rounded font-semibold mt-4 border-2 transition-all bg-white text-[#41264B] hover:shadow-lg hover:border-[#41264B] hover:bg-[#e6e3ea]"
            >
              More Info
            </button>
            <button
              type="button"
              onClick={goBack}
              className="w-full bg-gray-300 text-gray-800 py-2 rounded font-semibold mt-4 hover:bg-white border-2 border-gray-300"
            >
              Cancel
            </button>
          </div>
        </section>
      </div>
    </section>
  );
};

export default MindfulnessForm;
